import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Crop } from '../../common/_models';
import { CropService } from '../../common/_services';

@Pipe({
  name: 'commoditybyfieldandyear',
  pure: true,
  standalone: false,
})
export class CommoditybyfieldandyearPipe implements PipeTransform, OnDestroy {
  private cropList$: Observable<Crop[]>;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private translate: TranslateService,
    private cropService: CropService
  ) {
    this.cropList$ = this.cropService.getFromLocalStore();
  }

  transform(value: number, year: number): string | null {
    if (!value || !year) return null;

    const listCropNames: string[] = [];

    // Usa pipe per elaborare i dati e restituire il risultato direttamente
    const cropSubscription = this.cropList$
      .pipe(
        map((elements: Crop[]) => {
          elements.forEach((element) => {
            if (element.field.id === value && element.year === year) {
              const star = element.isPrimary ? '*' : '';
              const variety = element.variety?.name ? `(${element.variety.name})` : '';
              let season = '';

              if (element.season) {
                if (element.season === 'spring') {
                  season =
                    '<span class="season-icon spring-icon ms-1"><i class="fa-solid fa-sun"></i></span>';
                } else if (element.season === 'winter') {
                  season =
                    '<span class="season-icon winter-icon ms-1"><i class="fa-solid fa-snowflake"></i></span>';
                }
              }

              const idCountryCommodity = element.commodityCountryFields?.idCountryCommodity
                ? ` - ${element.commodityCountryFields.idCountryCommodity}`
                : '';

              listCropNames.push(
                this.translate.instant('select_commodity.' + element.commodity.name) +
                  star +
                  variety +
                  season +
                  idCountryCommodity
              );
            }
          });
        })
      )
      .subscribe();

    this.subscriptions.add(cropSubscription);

    // Verifica il risultato ed esegui l'unsubscribe
    if (listCropNames.length > 0) {
      return listCropNames.join(', ');
    } else {
      return null;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
